import { render, staticRenderFns } from "./EventPanels.vue?vue&type=template&id=6002434c&"
import script from "./EventPanels.vue?vue&type=script&lang=js&"
export * from "./EventPanels.vue?vue&type=script&lang=js&"
import style0 from "./EventPanels.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports